// store/authInitialState.ts
import { CollaboratorInfo } from '../../types';

/**
 * @french
 * État initial du slice d’authentification.
 */
export const cabinetInitialState = {
  collaborators: [] as CollaboratorInfo[],
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type CabinetState = typeof cabinetInitialState;
